var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderDefault = function SvgOrderDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.374 14.728h2.31a.8.8 0 0 1 .567 1.366l-2.312 2.31a.8.8 0 0 1-1.131 0l-2.311-2.31a.8.8 0 0 1 .565-1.366h2.312ZM12.373 10.243h2.311a.8.8 0 0 0 .566-1.366L12.94 6.566a.8.8 0 0 0-1.132 0l-2.31 2.311a.8.8 0 0 0 .565 1.366h2.311Z",
    fill: "currentColor"
  })));
};
export default SvgOrderDefault;